import { render, staticRenderFns } from "./SearchDataWasteModal.vue?vue&type=template&id=718a84c8&"
import script from "./SearchDataWasteModal.vue?vue&type=script&lang=js&"
export * from "./SearchDataWasteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports